import React, { Component } from 'react';

export default class Login extends Component {
    constructor(props) {
        super(props);
        this.state = {
            checking: true,
            username: '',
            password: '',
            error: null,
            done: false,
        };

        this.handleLoginButton = this.handleLoginButton.bind(this);
        this.handleUsernameChange = this.handleUsernameChange.bind(this);
        this.init();
    }

    async init() {
        try {
            await this.props.app.updateAccount();
        } finally {
            this.setState({checking:false});
        }
    }

    async handleLoginButton(event) {
        event.preventDefault();

        if (!this.state.username) {
            this.setState({error: "Please enter your e-mail or ImageOptim API username in the field below", checking:false});
            if (this.usernameInput) {
                this.usernameInput.focus();
            }
            return;
        }

        this.setState({checking: true, error: null});
        try {
            await this.props.app.logIn(this.state.username, this.state.password);
            this.setState({done: true});
        } catch(err) {
            this.setState({error: err.message || "Unknown error"});
            if (this.usernameInput) {
              this.usernameInput.focus();
            }
        } finally {
            this.setState({checking: false});
        }
    }

    handleUsernameChange(event) {
        this.setState({username: event.target.value});
    }

    render() {
        if (this.state.done) {
            return <div className="login-wait">Please check your e-mail. We&rsquo;ve sent a link that will log you in.</div>;
        }
        if (this.state.checking) {
            return <div className="login-wait">Checking, please wait…</div>;
        }
        return (<form className="login" onSubmit={this.handleLoginButton}>
          {this.state.error ? <p className="error"><strong>{this.state.error}</strong></p> : <h2>Log in to <abbr>API</abbr> Dashboard</h2>}
          <p>
            <label><span>Your e-mail or ImageOptim <abbr>API</abbr> username</span>
              <input autoFocus={true} type="text" value={this.state.username}
              name="username"
              onChange={this.handleUsernameChange}
              ref={el => {
                this.usernameInput = el;
              }}
              />
            </label>
          </p>
          <p><small>We don&rsquo;t have passwords!<br/>You will receive an e-mail with a link will log you in automatically.</small></p>
          <p><input type="submit" value="Log in" /></p>
        </form>);
    }
}



// WEBPACK FOOTER //
// ./src/ui/Login.jsx